import { render, staticRenderFns } from "./loansDistributionPieCard.vue.html?vue&type=template&id=3507372a&"
import script from "./loansDistributionPieCard.ts?vue&type=script&lang=ts&"
export * from "./loansDistributionPieCard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports